import { $, $$ } from '@utils';
import Collapsable from '@elements/Collapsable/Collapsable';

function init() {
  if (!$('[data-au-breadcrumbs]')) return;

  if (breadcrumbsCollapseCondition()) collapseBreadcrumbs();
}

function breadcrumbsCollapseCondition() {
  const breadcrumbs = $('[data-au-breadcrumbs]');
  const widthCondition = breadcrumbs.offsetWidth + 32 > breadcrumbs.parentElement.offsetWidth;
  const lengthCondition = $$('[data-au-breadcrumbs-item]').length > 5;

  return widthCondition || lengthCondition;
}

function collapseBreadcrumbs(index = 0) {
  const numOfItems = $$('[data-au-breadcrumbs-item]').length;

  if (index === 0) {
    createCollapsable();
    collapseBreadcrumbs(index + 1);

    return;
  }

  if ((breadcrumbsCollapseCondition() || numOfItems > 4) && numOfItems !== 2) {
    insertBreadcrumbInCollapsable();
    collapseBreadcrumbs(index + 1);
  }
}

function createCollapsable() {
  const container = $$('[data-au-breadcrumbs-item]')[1];
  const containerClone = container.cloneNode(true);
  const collapsableClone = $('[data-au-breadcrumbs-collapsable]').content.cloneNode(true);

  removeAttrItem([container, containerClone]);
  container.dataset.auBreadcrumbsContainer = '';
  container.innerHTML = '';
  container.appendChild(collapsableClone);
  $('[data-au-breadcrumbs-collapsable-list]').appendChild(containerClone);
  Collapsable.init('[data-au-breadcrumbs-collapsable-title]');
  $('[data-au-breadcrumbs-collapsable-close]').addEventListener('click', (e) =>
    e.target.closest('[data-au-collapsable-parent]').querySelector('[data-au-collapsable]').click(),
  );
}

function insertBreadcrumbInCollapsable() {
  const breadCrumbToMove = $$('[data-au-breadcrumbs-item]')[1];

  removeAttrItem([breadCrumbToMove]);
  $('[data-au-breadcrumbs-collapsable-list]').appendChild(breadCrumbToMove);
}

function removeAttrItem(elems) {
  elems.forEach((elem) => elem.removeAttribute('data-au-breadcrumbs-item'));
}

export default { init };
